import { render, staticRenderFns } from "./PayToSetup.vue?vue&type=template&id=13824552&scoped=true&"
import script from "./PayToSetup.vue?vue&type=script&lang=js&"
export * from "./PayToSetup.vue?vue&type=script&lang=js&"
import style0 from "./PayToSetup.vue?vue&type=style&index=0&id=13824552&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13824552",
  null
  
)

export default component.exports